import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { http, errMsg } from "@/lib/api";
import ImageManager from "@/components/extranet/ImageManager";

const EMPTY = { name: "", bed: "", max_guests: 2, size_m2: 24, base_price: 500000, rack_price: 0, total_rooms: 5, amenities: [], images: [], description: "",
  name_en: "", bed_en: "", amenities_en: [], description_en: "" };
const list = (v) => (typeof v === "string" ? v.split(",").map((s) => s.trim()).filter(Boolean) : v || []);

export default function RoomFormDialog({ open, onOpenChange, room, propertyId, onSaved }) {
  const [f, setF] = useState(EMPTY);
  useEffect(() => { if (open) setF(room ? { ...EMPTY, ...room } : EMPTY); }, [open, room]);
  const set = (k, num) => (e) => setF({ ...f, [k]: num ? Number(e.target.value) : e.target.value });

  const save = async () => {
    const body = { ...f, amenities: list(f.amenities), amenities_en: list(f.amenities_en) };
    try {
      if (room) await http.put(`/extranet/rooms/${room.id}`, body);
      else await http.post(`/extranet/properties/${propertyId}/rooms`, body);
      toast.success("Tipe kamar disimpan");
      onOpenChange(false); onSaved();
    } catch (e) { toast.error(errMsg(e)); }
  };

  const F = ({ k, label, num, span }) => (
    <div className={span ? "sm:col-span-2" : ""}><Label>{label}</Label>
      <Input data-testid={`room-form-${k}`} type={num ? "number" : "text"} value={f[k]} onChange={set(k, num)} className="mt-1.5" /></div>
  );
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="extranet max-h-[90vh] overflow-y-auto" data-testid="room-form-dialog">
        <DialogHeader><DialogTitle>{room ? "Edit tipe kamar" : "Tambah tipe kamar"}</DialogTitle></DialogHeader>
        <div className="grid gap-4 sm:grid-cols-2">
          {F({ k: "name", label: "Nama kamar", span: true })}
          {F({ k: "bed", label: "Tipe kasur" })}
          {F({ k: "size_m2", label: "Luas (m²)", num: true })}
          {F({ k: "max_guests", label: "Maks tamu", num: true })}
          {F({ k: "total_rooms", label: "Jumlah kamar fisik", num: true })}
          {F({ k: "base_price", label: "Harga dasar/malam (Rp)", num: true })}
          {F({ k: "rack_price", label: "Harga coret (Rp)", num: true })}
          <div className="sm:col-span-2"><Label>Fasilitas kamar (pisahkan koma)</Label>
            <Input data-testid="room-form-amenities" value={Array.isArray(f.amenities) ? f.amenities.join(", ") : f.amenities} onChange={set("amenities")} className="mt-1.5" /></div>
          <div className="sm:col-span-2"><Label>Foto kamar</Label><ImageManager testid="room-images" images={f.images || []} onChange={(v) => setF({ ...f, images: v })} /></div>
          <div className="sm:col-span-2"><Label>Deskripsi</Label>
            <Textarea data-testid="room-form-description" value={f.description} onChange={set("description")} className="mt-1.5" /></div>
          <div className="grid gap-4 rounded-md border border-dashed border-slate-300 p-4 sm:col-span-2 sm:grid-cols-2" data-testid="room-form-en">
            <p className="text-sm font-bold sm:col-span-2">English <span className="font-normal text-slate-500">— tampil saat tamu memilih EN; kosongkan untuk memakai teks Indonesia</span></p>
            {F({ k: "name_en", label: "Nama kamar (English)" })}
            {F({ k: "bed_en", label: "Tipe kasur (English)" })}
            <div className="sm:col-span-2"><Label>Fasilitas kamar (English, pisahkan koma)</Label>
              <Input data-testid="room-form-amenities-en" value={Array.isArray(f.amenities_en) ? f.amenities_en.join(", ") : f.amenities_en} onChange={set("amenities_en")} placeholder="Free WiFi, Air conditioning, Private bathroom" className="mt-1.5" /></div>
            <div className="sm:col-span-2"><Label>Deskripsi (English)</Label>
              <Textarea data-testid="room-form-description-en" value={f.description_en || ""} onChange={set("description_en")} className="mt-1.5" /></div>
          </div>
        </div>
        <DialogFooter><button data-testid="room-form-save" onClick={save} className="rounded-md bg-[#006CE4] px-5 py-2 font-semibold text-white hover:bg-[#0052B4]">Simpan</button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
